const AgricultureQuery = (id) => {
    return `
    query {
      deleteAgriculture(id: "${id}")
    } 
    `
}

export default AgricultureQuery